import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "items"]

  addItem() {
    const template = this.templateTarget.innerHTML
    const newItem = document.createElement('div')
    newItem.innerHTML = template
    this.itemsTarget.appendChild(newItem.firstElementChild)
  }

  removeItem(event) {
    const item = event.target.closest('[data-array-field-target="item"]')
    if (item) {
      item.remove()
    }
  }
}
